export type FeatureType = string | number;
export enum Feature {

   SearchFallBack = "SearchFallBack",
   BasicMap = "BasicMap",
   GeoCoding = "GeoCoding",
   SearchBar = "SearchBar",
   POI = "POI",
   GeodataReport = "GeodataReport",
   DeviceLocation = "DeviceLocation",
   ShowMapScale = "ShowMapScale",
   SaveMap = "SaveMap",
   ShowLayerControls = "ShowLayerControls",
   ShowMenu = "ShowMenu",
   ShowMapSettings = "ShowMapSettings",
   ShowMolbakLogoOnGeodataReport = "ShowMolbakLogoOnGeodataReport",
   Show360NorthLogoOnGeodataReport = "Show360NorthLogoOnGeodataReport",
   TravelTime = "TravelTime",
   UserAdmin = "UserAdmin",
   TravelTimeMultiple = "TravelTimeMultiple",
   SpatialExport = "SpatialExport",
   ObliquePhoto = "ObliquePhoto",
   GettingStarted = "GettingStarted",
   GeodataReportGermany = "GeodataReportGermany",
   TravelTimeRushHourMode = "TravelTimeRushHourMode",
   TravelTimeDownloadPolygons = "TravelTimeDownloadPolygons",
   SpatialExportGeoJSON = "SpatialExportGeoJSON",
   SpatialExportGeoJSONInverse = "SpatialExportGeoJSONInverse",
   SpatialExportGeoJsonPreview = "SpatialExportGeoJsonPreview",
   IntersectingPolygons = "IntersectingPolygons",
   Debugging = "Debugging",
   DebuggingOpenAllLinks = "DebuggingOpenAllLinks",
   ShowZoomLevelInHeader = "ShowZoomLevelInHeader",
   CreateMarker = "CreateMarker",
   CreateMarkerNavigation = "CreateMarkerNavigation",
   EditCustomFeatureLayers = "EditCustomFeatureLayers",
   ViewCustomFeatureLayers = "ViewCustomFeatureLayers",
   StreetView = "StreetView",
   LifaOIS = "LifaOIS",
   Kortviser = "Kortviser",
   PropertyInfo = "PropertyInfo",
   AdkomstDetaljer = "AdkomstDetaljer",
   ServitutDetaljer = "ServitutDetaljer",
   ServitutBerigelseReadAccess = "ServitutBerigelseReadAccess",
   ServitutBerigelseWriteAccess = "ServitutBerigelseWriteAccess",
   EjerlavMatrikelSearch = "EjerlavMatrikelSearch",
   MeasurementTool = "MeasurementTool",
   MeasurementToolSpatial = "MeasurementToolSpatial",
   DrawCircle = "DrawCircle",
   VisSamletFastEjendom = "VisSamletFastEjendom",
   VisVurderingsejendom = "VisVurderingsejendom",
   VisMatrikel = "VisMatrikel",
   PiechartClustering = "PiechartClustering",
   CustomUserSettingAdmin = "CustomUserSettingAdmin",
   ImportSettings = "ImportSettings",
   ImportPhotos = "ImportPhotos",
   ImportEnableSydslesvigGeom = "ImportEnableSydslesvigGeom",
   ImportEnableGrid = "ImportEnableGrid",
   ImportEnableRomaniaGeom = "ImportEnableRomaniaGeom",
   POIEVCharger = "POIEVCharger",
   ShowReleases = "ShowReleases",

   EditDataLayer = "EditDataLayer",
   MovePointPositions = "MovePointPositions",
   SaveLink = "SaveLink",
   SaveLinkAdvancedSettings = "SaveLinkAdvancedSettings",
   SaveLinkReuseMapLink = "SaveLinkReuseMapLink",
   SaveLinkSetRestrictions = "SaveLinkSetRestrictions",
   SaveLinkSelectFeatureLayers = "SaveLinkSelectFeatureLayers",
   SaveLinkAllowLogin = "SaveLinkAllowLogin",
   SaveLinkAllowMapPlot = "SaveLinkAllowMapPlot",
   SaveLinkShowUserLocation = "SaveLinkShowUserLocation",
   SaveLinkSelectSearchOptions = "SaveLinkSelectSearchOptions",
   SaveLinkSelectSearchBehaviour = "SaveLinkSelectSearchBehaviour",

   SaveMapCloud = "SaveMapCloud",
   SaveMapCustomerCloud = "SaveMapCustomerCloud",
   SaveMapAdminCloud = "SaveMapAdminCloud",

   SettingsCustomer = "SettingsCustomer",
   MapPlot = "MapPlot",
   MapPlotCompress = "MapPlotCompress",
   MapPlotSuper = "MapPlotSuper",
   MapPlotLogo = "MapPlotLogo",
   PowerUser = "PowerUser",


   ShowMenuAndControlsOnMap = "ShowMenuAndControlsOnMap",
   TravelTimeCombinedBikeAndTransit = "TravelTimeCombinedBikeAndTransit",
   TravelTimeFromPoint = "TravelTimeFromPoint",
   TravelTimeCalculateSeparately = "TravelTimeCalculateSeparately",
   TravelTimeMultipleBufferSetting = "TravelTimeMultipleBufferSetting",

   BroadcastReceiver = "BroadcastReceiver",

   ConflictSearch = "ConflictSearch",
   ConflictReport = "ConflictReport",
   ConflictMap = "ConflictMap",
   ConflictSheet = "ConflictSheet",

   // ----------------- Person Info Feature -----------------
   OpenPersonInfoDocument = "OpenPersonInfoDocument",
   PrintPersonInfo = "PrintPersonInfo",
   PropertyInfoFavorite = "PropertyInfoFavorite",

   // ----------------- Property Info Features --------------
   OpenPropetyInfoDocument = "OpenPropetyInfoDocument",
   BoligmarkedsStatistik = "BoligmarkedsStatistik",
   KortUdsnitEjendom = "KortUdsnitEjendom",
   PlandataAflyst = "PlandataAflyst",
   PlandataForslag = "PlandataForslag",
   LinkToMao = "LinkToMao",
   LinkToMunicipalityWebDocuments = "LinkToMunicipalityWebDocuments",
   Jordforureningsattest = "Jordforureningsattest",

   // ----------------- Explorer Features -------------------
   AddToProjectUnassignedList = "AddToProjectUnassignedList",
   Explorer = "Explorer",
   ExplorerDashboard = "ExplorerDashboard",
   ExplorerExplore = "ExplorerExplore",
   ExplorerOwnership = "ExplorerOwnership",
   ExplorerProjects = "ExplorerProjects",
   ExplorerToExcel = "ExplorerToExcel",
   ExplorerSaveAsNewLayer = "ExplorerSaveAsNewLayer",
   ExplorerImportExport = "ExplorerImportExport",
   ExplorerDiscover = "ExplorerDiscover",
   ExplorerMarkedsData = "ExplorerMarkedsData",
   ExplorerShowAsList = "ExplorerShowAsList",

   // ------------------ Theme Features -------------------
   ThemeNewSec = "ThemeNewSec",

   // ------------------ BNBO Features --------------------
   BNBOTool = "BNBOTool", // Access to BNBO Tool itself
   BNBOToolWriteAccess = "BNBOToolWriteAccess",
   BNBOToolArrondationCalc = "BNBOToolArrondationCalc",
   BNBOReplaceData = "BNBOReplaceData",
   BNBOProjectRead = "BNBOProjectRead", // On project level: Access to read project data
   BNBOProjectWrite = "BNBOProjectWrite", // On project level: Access to write project data
   BNBOProjectAdmin = "BNBOProjectAdmin", // On project level: Access to manage project properties/users
   BNBOToolAdmin = "BNBOToolAdmin", // Access to 1) customer projects 2) to import data 3) to manage users/organizations
   BNBOToolGlobalAdmin = "BNBOToolGlobalAdmin", // Access to all customers projects

   // ------------------ JPB Jordprisberegner Features --------------------
   JPBTool = "JPBTool", // Access to JPB Tool itself
   JPBIndexTool = "JPBIndexTool", // Access to JPB Index Builder tool
   JPBAgroCuraIndexAllow = "JPBAgroCuraIndexAllow", // Access to AgroCura index option in JPB subheader
   JPBMolbakIndexAllow = "JPBMolbakIndexAllow", // Access to Mølbak index option in JPB subheader
   JPBSimulator = "JPBSimulator", // Access to JPB Simulator
   JPBRapport = "JPBRapport", // Access to JPB Rapport export
   JPBExcelExport = "JPBExcelExport", // Access to JPB table Excel export

   // ------------------ (Batch) Jobs Features --------------------
   JobModule = "JobModule",
   JobModuleAdmin = "JobModuleAdmin",
   JobModuleGlobalAdmin = "JobModuleGlobalAdmin",
   JobTypeRead = "JobTypeRead",
   JobTypeWrite = "JobTypeWrite",
   JobTypeAdmin = "JobTypeAdmin",

   // ------------------ Map Styles ------------------------
   MapStyleViamap = "MapStyleViamap",
   MapStyleContrast = "MapStyleContrast",
   MapStyleLight = "MapStyleLight",
   MapStyleDark = "MapStyleDark",
   MapStyleAerial = "MapStyleAerial",
   MapStyleAerialNoMask = "MapStyleAerialNoMask",
   MapStyleBlank = "MapStyleBlank",

   // ------------------ ScreenSizes -----------------------
   DeviceScreenSizePhone = "DeviceScreenSizePhone",
   DeviceScreenSizeTablet = "DeviceScreenSizeTablet",
   DeviceScreenSizeNormal = "DeviceScreenSizeNormal",

   // ------------------ Background Layers -------------------
   ShareFavoriteBackgroundLayers = "ShareFavoriteBackgroundLayers",
   FavoriteBackgroundLayers = "FavoriteBackgroundLayers",

   HexagonBackgroundLayerMoelbak = "HexagonBackgroundLayerMoelbak",
   CowiBackgroundLayerMoelbak = "CowiBackgroundLayerMoelbak",
   BackgroundLayerOwnerInformation = "BackgroundLayerOwnerInformation",
   BackgroundLayerFloodingFromSea = "BackgroundLayerFloodingFromSea",
   BackgroundLayerRainFall = "BackgroundLayerRainFall",


   BackgroundLayerDHM = "BackgroundLayerDHM",
   BackgroundLayerFikspunkt = "BackgroundLayerFikspunkt",

   BackgroundLayerBBRData = "BackgroundLayerBBRData",
   BackgroundLayerEjerData = "BackgroundLayerEjerData",
   BackgroundLayerZoning = "BackgroundLayerZoning",

   BackgroundLayerLocalPlans = "BackgroundLayerLocalPlans",
   BackgroundLayerDAI = "BackgroundLayerDAI",
   BackgroundLayerDayNightPopulation = "BackgroundLayerDayNightPopulation",
   BackgroundLayerPrivatVej = "BackgroundLayerPrivatVej",
   BackgroundLayerStrandBeskyttelsesLinjer = "BackgroundLayerStrandBeskyttelsesLinjer",
   BackgroundLayerFredsskov = "BackgroundLayerFredsskov",
   BackgroundLayerForeloebigeSkel = "BackgroundLayerForeloebigeSkel",
   BackgroundLayerCadasterPoints = "BackgroundLayerCadasterPoints",
   BackgroundLayerPoliceDistricts = "BackgroundLayerPoliceDistricts",
   BackgroundLayerJordforureningV1 = "BackgroundLayerJordforureningV1",
   BackgroundLayerJordforurening_NuanceringV2 = "BackgroundLayerJordforurening_NuanceringV2",
   BackgroundLayerAnvendelse2021 = "BackgroundLayerAnvendelse2021",

   BackgroundLayerStøj = "BackgroundLayerStøj",
   BackgroundLayerStøjNat = "BackgroundLayerStøjNat",

   // Uddeleger til lag
   BackgroundLayerHistoriskeKort = "BackgroundLayerHistoriskeKort",
   BackgroundLayerHistoriskeOrto = "BackgroundLayerHistoriskeOrto",
   BackgroundLayerHistoriskeOrtofoto = "BackgroundLayerHistoriskeOrtofoto",
   BackgroundLayerOrtofotoSommer = "BackgroundLayerOrtofotoSommer",
   BackgroundLayerAdmGrænser = "BackgroundLayerAdmGrænser",
   BackgroundLayerAdmGrænserExtended = "BackgroundLayerAdmGrænserExtended",
   BackgroundLayerAdmGrænserStednavne = "BackgroundLayerAdmGrænserStednavne",
   BackgroundLayerCadaster = "BackgroundLayerCadaster",
   BackgroundLayerCadasterExpanded = "BackgroundLayerCadasterExpanded",
   BackgroundLayerCadasterForeløbigSimple = "BackgroundLayerCadasterForeløbigSimple",
   BackgroundLayerCadasterForeløbig = "BackgroundLayerCadasterForeløbig",
   BackgroundLayerCadasterSUT = "BackgroundLayerCadasterSUT",
   BackgroundLayerAnvendelse = "BackgroundLayerAnvendelse",
   BackgroundLayerPlanData = "BackgroundLayerPlanData",
   BackgroundLayerPlanDataForsyning = "BackgroundLayerPlanDataForsyning",
   BackgroundLayerPlanDataKonsekvens = "BackgroundLayerPlanDataKonsekvens",
   BackgroundLayerPlanDataFingerPlan = "BackgroundLayerPlanDataFingerPlan",
   BackgroundLayerFredningerKulturArv = "BackgroundLayerFredningerKulturArv",
   BackgroundLayerByggeBeskyt = "BackgroundLayerByggeBeskyt",
   BackgroundLayerBeskyttetNatur = "BackgroundLayerBeskyttetNatur",
   BackgroundLayerVeje = "BackgroundLayerVeje",
   BackgroundLayerVejeTrafikVolumen = "BackgroundLayerVejeTrafikVolumen",
   BackgroundLayerForurening = "BackgroundLayerForurening",
   BackgroundLayerMarkblokke = "BackgroundLayerMarkblokke",
   BackgroundLayerMarkblokkeHist = "BackgroundLayerMarkblokkeHist",
   BackgroundLayerGeoDanmark = "BackgroundLayerGeoDanmark",
   BackgroundLayerJordbrug = "BackgroundLayerJordbrug",
   BackgroundLayerJordbrugVand = "BackgroundLayerJordbrugVand",

   BackgroundLayerBiodiversitet = "BackgroundLayerBiodiversitet",
   BackgroundLayerVandløbOversvoemmelse = "BackgroundLayerVandløbOversvoemmelse",

   BackgroundLayerPlanDataTrafikAnlæg = "BackgroundLayerPlanDataTrafikAnlæg",
   BackgroundLayerJordbrugDrikkevand = "BackgroundLayerJordbrugDrikkevand",
   BackgroundLayerGrundvand = "BackgroundLayerGrundvand",
   BackgroundLayerDDM = "BackgroundLayerDDM",
   BackgroundLayerMiljoe = "BackgroundLayerMiljoe",

   // ---------------- Features Demo and Experimental -------

   ExperimentalStyleSwitch = "ExperimentalStyleSwitch",


   BackgroundLayerSkovFonden = "BackgroundLayerSkovFonden",
   BackgroundLayerRetention = "BackgroundLayerRetention",

   // ---------------- Features for Reports ------------

   Datarapport = "Datarapport",
   Matrikeloversigt = "Matrikeloversigt",
   Markoversigt = "Markoversigt",
   Servitutoversigt = "Servitutoversigt",

   Servituterklaering = "Servituterklaering",



   BackgroundLayerDemo = "BackgroundLayerDemo",
   DownloadAktFraTinglysning = "DownloadAktFraTinglysning",
   /** Tingbog attest (ejendom summarisk) and digital dokument PDFs via API (post-2009). */
   FetchNewTingbogAllow = "FetchNewTingbogAllow",
   ServitutTilExcel = "ServitutTilExcel",
   LayerFunctions = "LayerFunctions",
   ShowDemoQuickButtons = "ShowDemoQuickButtons",
   SwapLicense = "SwapLicense",
   AllowConsolidateDuplicates = "AllowConsolidateDuplicates",
   PrintPropertyInfo = "PrintPropertyInfo",
   StylingSelectTextFont = "StylingSelectTextFont",
   StylingSelectPointType = "StylingSelectPointType",
   PoiSaveAsNewLayer = "PoiSaveAsNewLayer",
   ExportFloodingProperties = "ExportFloodingProperties", // Export Explore Result to Excel is extended with ground height and basement area information
   ExplorerSearchByMapLayer = "ExplorerSearchByMapLayer", // Explorer may search by a polygon Map Layer (imported from json or drawn).
   DuplicateLayer = "DuplicateLayer",
   DuplicateLayerFiltered = "DuplicateLayerFiltered",
   EarlyPreview = "EarlyPreview", // Access to preview of prototypes of new functionality

   // ---------------- Features for Molbak ------------
   LinkHistoriskeKort = "LinkHistoriskeKort",


   // ---------------- Features for webSocket ------------
   Websocket = "Websocket",
   WebsocketGlobalChat = "WebsocketGlobalChat",


   // ---------------- Features for MapInfo ------------
   EditMapDescription = "EditMapDescription",
   BackgroundGeusVandboringer = "BackgroundGeusVandboringer",

   // ---------------- Features for MapStyles ------------
   mapStyleMod = "mapStyleMod",

   mapStyle_Americana = "mapStyle_Americana",
   mapStyle_Bright = "mapStyle_Bright",
   mapStyle_DarkMatter = "mapStyle_DarkMatter",
   mapStyle_Outdoors = "mapStyle_Outdoors",
   mapStyle_Positron = "mapStyle_Positron",
   mapStyle_Toner = "mapStyle_Toner",
   mapStyle_Balder = "mapStyle_Balder",
   mapStyle_Campaya = "mapStyle_Campaya",
   mapStyle_Danbolig = "mapStyle_Danbolig",
   mapStyle_GenericDefaultStyle = "mapStyle_GenericDefaultStyle",
   mapStyle_Kjeldskov = "mapStyle_Kjeldskov",
   mapStyle_Klokantech = "mapStyle_Klokantech",
   mapStyle_Marselisborg = "mapStyle_Marselisborg",


   // -------------- Features for Data styling ---------------
   CopyPasteStyling = "CopyPasteStyling",

   // Features for FRP Module
   FRPTool = "FRPTool", // Access to FRP Tool itself
   FRPToolWriteAccess = "FRPToolWriteAccess",
   FRPReplaceData = "FRPReplaceData",
   FRPProjectRead = "FRPProjectRead", // On project level: Access to read project data
   FRPProjectWrite = "FRPProjectWrite", // On project level: Access to write project data
   FRPProjectAdmin = "FRPProjectAdmin", // On project level: Access to manage project properties/users
   FRPToolAdmin = "FRPToolAdmin", // Access to 1) customer projects 2) to import data 3) to manage users/organizations
   FRPToolGlobalAdmin = "FRPToolGlobalAdmin", // Access to all customers projects

   // -------------- Features for Annotation Module ---------------
   ImageOverlay = "ImageOverlay",
   AnnotationModule = "AnnotationModule",
   AnnotationModuleAdmin = "AnnotationModuleAdmin",
   AnnotationRead = "AnnotationRead",
   AnnotationWrite = "AnnotationWrite",
   AnnotationDelete = "AnnotationDelete",
   AnnotationAuthUser = "AnnotationAuthUser", // Access to verify quality assessments
   ServitutEditor = "ServitutEditor", // Access to open servitut PDFs in editor
   ServitutAIAnalyse = "ServitutAIAnalyse", // Access to run AI analysis on servitut PDFs

   // ----------------- Debugging Features --------------
   SimulateOtherUser = "SimulateOtherUser",

   // ----------------- Features not Appointed Rights --------
   NotActive = "NotActive",
   RawExplorer = "RawExplorer",
   PropertyExcel = "PropertyExcel",

}